<template>
  <el-popover v-model="showPopover" popperClass="p-2" trigger="click" :width="200">
    <el-form :model="formModificarReaparto">
      <el-row>
        <el-col :span="24">
          <el-form-item label="Modo reparto">
            <el-switch
              v-model="formModificarReaparto.switchMode"
              size="mini"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Auto"
              active-value="auto"
              inactive-text="Manual"
              inactive-value="manual"
              @change="onChangeSwitchMode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Escoge franja">
            <el-select
              v-model="formModificarReaparto.selectSlotManualMode"
              placeholder="Selecciona"
              :disabled="formModificarReaparto.switchMode === 'auto'"
            >
              <el-option
                v-for="(slot, idx) in timeslots"
                :key="`${idx}-${slot.name}`"
                :label="slot.name"
                :value="slot.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="text-right">
          <el-button size="mini" type="text" @click="onCancelUpdateReparto"> Cancelar </el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="isDisabledBtnUpdate"
            @click="onUpdateReparto"
          >
            Modificar
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-button
      v-show="configsMode"
      slot="reference"
      type="text"
      class="pr-4 mt-1 py-0"
      style="cursor: pointer"
    >
      <div style="display: flex; align-items: center">
        <i class="material-icons mr-1" style="font-size: 34px">playlist_play</i>
        <div class="text-left">
          <template v-if="configsMode === 'auto'">
            <div>Reparto automático</div>
            <div class="ml-1 name-reparto">{{ getNameFranjaReparto() }}</div>
          </template>
          <template v-else>
            <div class="ml-1" style="color: #e65d6e; font-weight: 700">Reparto manual</div>
            <div class="ml-1">
              {{ configsSlotsManualMode }}
            </div>
          </template>
        </div>
      </div>
    </el-button>
  </el-popover>
</template>

<script>
import { getConfigByName } from "@/api/operations/config.ts";
import moment from "@/utils/moment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PopoverInfoReparto",

  data() {
    return {
      showPopover: false,
      formModificarReaparto: {
        switchMode: "auto",
        selectSlotManualMode: "",
      },
      timeslots: [],
    };
  },

  created() {
    this.loadTimeStots();
  },

  computed: {
    ...mapGetters("clientConfigs", ["configs", "configsMode", "configsSlotsManualMode"]),
    ...mapGetters("app", ["defaultWorkgroup"]),

    isDisabledBtnUpdate() {
      return (
        this.formModificarReaparto.switchMode === "manual" &&
        !this.formModificarReaparto.selectSlotManualMode
      );
    },
  },

  watch: {
    configs(newVal) {
      if (newVal) {
        this.formModificarReaparto = {
          switchMode: newVal.mode,
          selectSlotManualMode: newVal.slotManualMode,
        };
      }
    },
  },

  methods: {
    ...mapActions("clientConfigs", ["updateConfigs"]),

    async loadTimeStots() {
      this.timeslots = (await getConfigByName(this.defaultWorkgroup.id, "deliveryMode")).timeslots;
    },

    getNameFranjaReparto() {
      const now = moment()();
      let currentDayOfWeek = moment()().day();
      currentDayOfWeek = currentDayOfWeek === 0 ? 7 : currentDayOfWeek;
      return (
        this.timeslots.find((slot) => {
          return slot.ranges?.some((r) => {
            if (r.dateFrom) {
              return (
                moment()(r.dateFrom).isSameOrBefore(now) && moment()(r.dateTo).isSameOrAfter(now)
              );
            } else {
              return (
                r.daysOfWeek &&
                r.daysOfWeek.includes(currentDayOfWeek) &&
                moment()(r.from, "HH:mm").isBefore(now) &&
                moment()(r.to, "HH:mm").isAfter(now)
              );
            }
          });
        })?.name || "Franja por defecto"
      );
    },

    onChangeSwitchMode(mode) {
      if (mode === "auto") {
        this.formModificarReaparto.selectSlotManualMode = null;
      }
    },

    async onUpdateReparto() {
      this.configs.mode = this.formModificarReaparto.switchMode;
      this.configs.slotManualMode = this.formModificarReaparto.selectSlotManualMode;
      const payload = {
        params: {
          name: "deliveryMode",
        },
        data: this.configs,
      };
      const isOk = await this.updateConfigs(payload);
      if (isOk) {
        this.$message({
          type: "success",
          message: "Configuración actualizada",
        });
        this.showPopover = false;
        this.getNameFranjaReparto();
      } else {
        this.$message({
          type: "error",
          message: "Problemas actualizando la configuración",
        });
      }
    },

    onCancelUpdateReparto() {
      this.showPopover = false;
      this.formModificarReaparto = {
        switchMode: this.configs.mode,
        selectSlotManualMode: this.configs.slotManualMode,
      };
    },
  },

  mounted() {
    this.intervalName = setInterval(() => {
      this.getNameFranjaReparto();
    }, 2000);
  },

  beforeDestroy() {
    clearInterval(this.intervalName);
  },
};
</script>

<style lang="scss" scoped>
.name-reparto {
  font-style: italic;
  color: #bfcbd9;
  font-weight: 700;
}
</style>
